export default __webpack_public_path__ + "static/media/wetest-logo.afb849e6.svg";